import { useQuery } from "@grandvisionhq/graphql";
import { toRecentOrders } from "../../../mappers/Profile/mappers/profile.js";
import GET_RECENT_ORDERS from "../../../operations/queries/Profile/operations/queries/get-recent-orders.js";
const useRecentOrders = () => {
  const { data, loading, error } = useQuery(GET_RECENT_ORDERS);
  const orders = data?.me?.orders?.results.slice(0, 2);
  return {
    data: orders && toRecentOrders(orders),
    hasRecentOrders: !!orders?.length,
    loading,
    error
  };
};
export {
  useRecentOrders
};
//# sourceMappingURL=use-recent-orders.js.map
